import { IS_BILLING_CUSTOM_DOWNGRADE_FLOWS_ENABLED } from '@/components/constants/flags';
import {
  cancellationConfirmationModalOpenAtom,
  retentionDiscountOfferModalOpenAtom,
} from '@/features/settings/billing/billingAtoms';
import { useAtomValue } from 'jotai';

import { CancellationConfirmationModal } from './cancellation-confirmation-modal';
import { ClinicianSessionOfferModal } from './clinician-session-offer-modal';
import { RetentionDiscountOfferModal } from './retention-discount-offer-modal';

/** Downgrade retention modals; gated by billing custom-flow flag. */
export function DowngradeRetentionFlowModals() {
  const cancellationOpen = useAtomValue(cancellationConfirmationModalOpenAtom);
  const retentionOpen = useAtomValue(retentionDiscountOfferModalOpenAtom);

  if (!IS_BILLING_CUSTOM_DOWNGRADE_FLOWS_ENABLED()) {
    return null;
  }

  return (
    <>
      {cancellationOpen && <CancellationConfirmationModal />}
      {retentionOpen && <RetentionDiscountOfferModal />}
      <ClinicianSessionOfferModal />
    </>
  );
}
